module.exports = __webpack_public_path__ + "fonts/DINPro-CondLight.5c04b395.otf";